import React from 'react'
import { Container } from 'reactstrap'
import { times } from 'lodash'

import mobileWave from '../../images/background/wave-billboard-mobile.svg'
import desktopWave from '../../images/background/wave-billboard-desktop.svg'

import wmobileWave from '../../images/background/wave-billboard-mobile-white.svg'
import wdesktopWave from '../../images/background/wave-billboard-desktop-white.svg'

const Billboard = ({ children, className, color, circles = true, ...rest }) => {
  return (
    <section className={`Billboard ${className}`} {...rest}>
      {circles && (
        <ul className="circles">
          {times(20, (i) => (
            <li key={i}></li>
          ))}
        </ul>
      )}

      {color === 'white' ? (
        <React.Fragment>
          <img src={wmobileWave} className="Billboard__mobileWave" alt="" />
          <img src={wdesktopWave} className="Billboard__desktopWave" alt="" />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <img src={mobileWave} className="Billboard__mobileWave" alt="" />
          <img src={desktopWave} className="Billboard__desktopWave" alt="" />
        </React.Fragment>
      )}

      <Container>
        <div className="Billboard__inner">{children}</div>
      </Container>
    </section>
  )
}

export default Billboard
